import { useEffect, useState } from 'react';
import type { DisplayPublic } from '../api';
import { ChannelChrome } from './ChannelChrome';

const SLIDES = [
  { color: '#0f172a', accent: '#3b82f6', label: 'YOUR LOGO' },
  { color: '#1e1b4b', accent: '#a855f7', label: 'YOUR LOGO' },
  { color: '#3f0f0f', accent: '#ef4444', label: 'YOUR LOGO' },
  { color: '#052e16', accent: '#22c55e', label: 'YOUR LOGO' },
];

const ROTATION_MS = 8000;

export function AdOnlyChannel({
  display,
  connected,
  onUnpair,
}: {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
}) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((x) => (x + 1) % SLIDES.length), ROTATION_MS);
    return () => clearInterval(id);
  }, []);
  const s = SLIDES[i];
  return (
    <ChannelChrome
      display={display}
      connected={connected}
      onUnpair={onUnpair}
      variant="minimal"
    >
      <div
        className="flex flex-1 items-center justify-center transition-colors duration-1000"
        style={{ background: s.color }}
      >
        <div className="text-center">
          <div
            className="mx-auto h-48 w-48 rounded-3xl"
            style={{ background: s.accent }}
          />
          <div
            className="mt-12 font-mono text-3xl tracking-[0.5em]"
            style={{ color: s.accent }}
          >
            {s.label}
          </div>
        </div>
      </div>
    </ChannelChrome>
  );
}
